<div class="order-transfer-table table__container">
  <table class="lum-table lum-table--classic striped">
    <thead>
      <tr class="table__head-row">
        <ng-container *ngFor="let column of columns; let idx = index">
          <th *ngIf="column.visible">{{ column.label }}</th>
        </ng-container>
        <th style="width: 120px">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let order of orderTransfers">
        <tr>
          <td *ngIf="columnAsObject?.orderNo?.visible">
            <a
              [routerLink]="['/inventory/transfer-order', order.id]"
              class="text-link"
            >
              {{ order.orderNumber }}
            </a>
          </td>
          <td *ngIf="columnAsObject?.orderDate?.visible">
            {{ order.orderDate | date }}
          </td>
          <td *ngIf="columnAsObject?.orderStatus?.visible">
            <span
              [class]="
                'lum-chip lum-chip--label lum-chip--small' +
                (order.orderStatus === orderTransferStatus.POSTED
                  ? ' bg-purple-600 text-white'
                  : '')
              "
            >
              {{ order.orderStatus }}
            </span>
          </td>
          <td *ngIf="columnAsObject?.arrivalDate?.visible">
            {{ order.arrivalDate | date }}
          </td>
          <td *ngIf="columnAsObject?.sourceWarehouse?.visible">
            {{ order.sourceWarehouse?.locationName }}
          </td>
          <td *ngIf="columnAsObject?.destinationWarehouse?.visible">
            {{ order.destinationWarehouse?.locationName }}
          </td>
          <td *ngIf="columnAsObject?.createBy?.visible">
            {{ order.createdBy?.fullName }}
          </td>
          <td *ngIf="columnAsObject?.updatedBy?.visible">
            {{ order.updatedBy?.fullName }}
          </td>
          <td *ngIf="columnAsObject?.createdAt?.visible">
            {{ order.createdAt | date }}
          </td>
          <td *ngIf="columnAsObject?.updatedAt?.visible">
            {{ order.updatedAt | date }}
          </td>
          <td *ngIf="columnAsObject?.supplierPoNo?.visible">
            <ng-container *ngIf="order.supplierPurchaseOrder">
              <a
                target="_blank"
                [routerLink]="['/orders', order.supplierPurchaseOrder?.id]"
              >
                #{{ order.supplierPurchaseOrder?.id }}
              </a>
              <div *ngIf="order.supplierPurchaseOrder?.modelAlternateIds?.length" class="mt-1">
                <small class="text-gray-600">Alternate IDs:</small>
                <div class="flex flex-wrap gap-1 mt-1">
                  <a
                    *ngFor="let alternateId of order.supplierPurchaseOrder?.modelAlternateIds; trackBy: trackByValue"
                    [routerLink]="['/orders']"
                    [queryParams]="{ alternateIds: alternateId.alternateId }"
                    class="lum-chip lum-chip--label lum-chip--small bg-gray-100 text-link"
                  >
                    {{ alternateId.alternateId }}
                  </a>
                </div>
              </div>
            </ng-container>
          </td>
          <td *ngIf="columnAsObject?.salesOrderNo?.visible">
            <ng-container *ngIf="order.salesOrder">
              <a
                target="_blank"
                [routerLink]="['/shipping/posted-orders', order.salesOrder?.id]"
              >
                {{ order.salesOrder?.orderNumber }}
              </a>
            </ng-container>
          </td>
          <td class="table__line-item" *ngIf="columnAsObject?.lineItems?.visible">
            <ul class="list-unstyled" style="width: 285px">
              <ng-container *ngFor="let item of order.orderItems | slice: 0 : 2">
                <li class="text-ellipsis">
                  [{{ item.internalSku }}] {{ item.productName }}
                  <i>x {{ item.orderedQty }}</i>
                </li>
              </ng-container>
              <ng-container *ngIf="(order.orderItems || []).length >= 3">
                <li>
                  <a
                    role="button"
                    class="text-purple-600"
                    (click)="onShowOrderItems(order)"
                    >>> Show All</a
                  >
                </li>
              </ng-container>
            </ul>
          </td>
          <td class="flex justify-end position-sticky" style="right: 0">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menuActions"
              (click)="$event.stopPropagation()"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
          <mat-menu #menuActions="matMenu">
            <button
              [disabled]="order.orderStatus === orderTransferStatus.POSTED"
              (click)="onValidateAction(order, 'edit')"
              mat-menu-item
            >
              <i class="fas fa-edit"></i> Edit
            </button>
            <button
              class="text-danger"
              (click)="onValidateAction(order, 'delete')"
              mat-menu-item
            >
              <i class="fas fa-trash"></i> Delete
            </button>
          </mat-menu>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
